import { ACTIONS } from '../../constants/actionConstants';

export const setFilterState = (data: any) => {
  return {
    type: ACTIONS.SET_FILTER_STATE,
    data,
  };
};
